"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isBrowser = _interopRequireDefault(require("./is-browser"));

/**
 * Checks if the browser supports local storage setItem and removeItem.
 * @returns boolean True if the browser supports local storage, false otherwise.
 */
var localStorageCheck = function localStorageCheck() {
  if (!(0, _isBrowser["default"])()) return false;
  var key = '_localStorageCheck';

  try {
    localStorage.setItem(key, key);
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

var _default = localStorageCheck;
exports["default"] = _default;